import { OrderDetailsFormFieldsNames, TOrderDetailsFormValues } from './types';

export const hasUnsavedOrderComments = (
  comments: TOrderDetailsFormValues[OrderDetailsFormFieldsNames.COMMENTS] | undefined,
): boolean => {
  if (!comments) {
    return false;
  }

  return Object.values(comments).some((value) => typeof value === 'string' && value.trim().length > 0);
};
